import { Injectable } from '@angular/core';

import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class BehaviorDataService {
    private userConfig = new BehaviorSubject('');
    getUserConfig = this.userConfig.asObservable();

    private showCCDepositLimitCheckMsg = new BehaviorSubject(false);
    getCCDepositLimitCheckMsg = this.showCCDepositLimitCheckMsg.asObservable();

    private enteredAmount = new BehaviorSubject('');
    getEnteredAmount = this.enteredAmount.asObservable();

    private cvv2 = new BehaviorSubject('');
    getCVV2 = this.cvv2.asObservable();

    private bonusTnC = new BehaviorSubject(true);
    getbonusTnC = this.bonusTnC.asObservable();

    private isPaypalBadFunding = new BehaviorSubject(false);
    getPaypalBadFunding = this.isPaypalBadFunding.asObservable();

    changeMaxFailDepEnhancement = new BehaviorSubject(null);

    private stakeAmount = new BehaviorSubject('');
    getStakeAmount = this.stakeAmount.asObservable();

    private stakeCurrency = new BehaviorSubject('');
    getStakeCurrency = this.stakeCurrency.asObservable();

    estimatedReturn = new BehaviorSubject(0.0);
    changeAmountRequiredToMeetStake = new BehaviorSubject(0.0);
    isFullStakeAmountNotMet = new Subject();
    amountInAccCurrency = new BehaviorSubject<any>('');
    isBetSuspended = new BehaviorSubject<any>(false);
    isPriceChanged = new BehaviorSubject<any>(false);
    setUserConfig(data: any) {
        this.userConfig.next(data);
    }

    changeshowCCDepositLimitCheckMsg(data: boolean) {
        this.showCCDepositLimitCheckMsg.next(data);
    }

    changeEnteredAmount(data: string) {
        this.enteredAmount.next(data);
    }

    changeCVV2(data: string) {
        this.cvv2.next(data);
    }

    changebonusTnC(data: boolean) {
        this.bonusTnC.next(data);
    }

    changePaypalBadFunding(data: boolean) {
        this.isPaypalBadFunding.next(data);
    }

    changeStakeAmount(data: any) {
        this.stakeAmount.next(data);
    }

    changeStakeCurrency(data: string) {
        this.stakeCurrency.next(data);
    }
}
